import { render, staticRenderFns } from "./AcceuilPaiemClient.vue?vue&type=template&id=54b304c1&"
import script from "./AcceuilPaiemClient.vue?vue&type=script&lang=js&"
export * from "./AcceuilPaiemClient.vue?vue&type=script&lang=js&"
import style0 from "./AcceuilPaiemClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports